import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { FeedbackContent } from '@/features/wizard/components/FeedbackContent';

export const Route = createFileRoute('/_dashboard/interactions/feedback/$id')({
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();
  const navigate = useNavigate();

  const handleBack = () => {
    navigate({ to: '/' });
  };

  return <FeedbackContent feedbackId={id} onBack={handleBack} />;
}
